import styled from '@emotion/styled'
import React from 'react'

export interface IButtonTypes
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  primary?: boolean
}

export const Button = ({ primary, ...props }: IButtonTypes) => {
  const { Container, ButtonLayout } = Button

  return (
    <Container>
      <ButtonLayout {...props} primary={primary} />
    </Container>
  )
}
Button.Container = styled.div``

Button.ButtonLayout = styled.button<any>(
  (props) => `
  all: unset;
  transition: 0.29s all;
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 120%;
  font-weight: 600;
  border: 2px solid #292926;
  color: #292926;
  text-align: center;
  background-color: transparent;
  cursor: pointer;
  &:not(:disabled):hover {
    filter: brightness(90%);
  }
  ${
    props.primary &&
    `
    background: #292926;
    color: #FFFFFF;
  `
  }
  &:disabled {
    background: #EAEAE9;
    color: #AAAAA8;
  }
`
)
